import styled from 'styled-components'
import L from '../../Components/L'

const CollectionsStyles = theme => ({
  collectionRowHead: {
    ...theme.mixins.gridColumns(theme.spacing(2)),
    alignItems: 'center',
    justifyContent: 'space-between',
    userSelect: 'none',
    cursor: 'pointer',
  },
  collectionRowTitle: {
    position: 'relative',
  },
  showBorder: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.palette.border.dark,
    transition: theme.globals.transition,
  },
  hideBorder: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: 'transparent',
    transition: theme.globals.transition,
  },
  tabs: {
    boxShadow: theme.globals.boxShadowSmaller,
    zIndex: theme.zIndex.secondary,
  },
})

const SimulationGrid = styled.div`
  & > div {
    border-top: ${props => props.theme.globals.divider};
    &:last-of-type {
      border-bottom: ${props => props.theme.globals.divider};
    }
  }
`

const ShadowBox = styled.div`
  position: absolute;
  top: -9px;
  left: 0;
  width: 100%;
  height: 9px;
  box-shadow: ${props => (props.active ? '0 5px 6px 0px rgba(0,0,0,.16)' : 'none')};
  transition: ${props => props.theme.mixins.transition(['box-shadow'])};
`

const StyledMenuItemInner = styled(L).attrs({
  display: 'grid',
  flow: 'column',
  ai: 'center',
  gap: 1,
})`
  ${props => props.isDisabled && `opacity: .5; pointer-events: none;`}
`

export { SimulationGrid, ShadowBox, StyledMenuItemInner, CollectionsStyles }
